import React from "react"
import { FiChevronLeft } from 'react-icons/fi'
import { Row, Col, Button } from "react-bootstrap"
import { statiProposta } from "../../../Utilities/statiElementEnum"

export default function AzioniProposta(props) {

    return (
        <>
            <Row className="mt-3 mb-5">
                <Col xs={{ span: 12, order: 3 }} md={{ span: 2, order: 1 }}>
                    <Button variant="outline-dark"
                        className="w-100 my-2 my-md-1 shadow"
                        onClick={() => props.setGestisci("proposte-elenco")}>
                        <FiChevronLeft />
                        Indietro
                    </Button>
                </Col>

                {props.gestisciProposta === "controlla" &&
                    <>
                        <Col xs={{ span: 12, order: 2 }} md={{ span: 2, offset: 6, order: 2 }}>
                            <Button className="w-100 my-2 my-md-1 shadow"
                                variant="outline-secondary"
                                onClick={props.preparaRifiuta}
                            >
                                Rifiuta
                            </Button>
                        </Col>
                        <Col xs={{ span: 12, order: 1 }} md={{ span: 2, order: 3 }}>
                            <Button className="w-100 my-2 my-md-1 shadow"
                                variant="primary"
                                onClick={
                                    e => {
                                        props.handleSubmit("pubblica", e)
                                    }
                                }
                            >
                                Salva e pubblica
                            </Button>
                        </Col>
                    </>
                }

                {(props.gestisciProposta === "rispondi" && props.stato !== statiProposta.Rifiutata) &&
                    <Col xs={{ span: 12, order: 1 }} md={{ span: 2, order: 3, offset:8  }}>
                        <Button className="w-100 my-2 my-md-1 shadow"
                            variant="primary"
                            onClick={e => { props.handleSubmit("rispondi", e) }}
                        >
                            Rispondi alla proposta
                        </Button>
                    </Col>
                }

                {/* {props.stato === statiProposta.Rifiutata &&
                    <Col xs={{ span: 12, order: 1 }} md={{ span: 2, order: 3 , offset:8}}>
                        <Button className="w-100 my-2 my-md-1 shadow"

                            variant="primary"
                            onClick={e => { props.handleSubmit("pubblica", e) }}
                        >
                            Pubblica proposta
                        </Button>
                    </Col>

                } */}

                {props.gestisciProposta === "firme" &&
                    <Col xs={{ span: 12, order: 1 }} md={{ span: 2, order: 3 , offset:8}}>
                        <Button className="w-100 my-2 my-md-1 shadow"
                            variant="primary"
                            onClick={e => { props.handleSubmit("firme", e) }}
                        >
                            Registra firme
                        </Button>
                    </Col>
                }

            </Row>
        </>
    )
}